import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import QuestionFileUpload from "../../QuestionFileUpload";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const CheckboxQuestion = ({
  q,
  sectionIndex,
  error,
  handleChange,
  formData,
  setFormData,
  isDisabled,
  handleFiles
}) => {
  const { t } = useTranslation()
  const [answers, setAnswers] = useState([])

  useEffect(() => {
    setAnswers(q.answers || [])
  }, [])


  const handleCheckboxChange = (opt, checked) => {
    let newAns = [...answers];
    if (checked) newAns.push(opt.id);
    else newAns = newAns.filter(a => a !== opt.id);
    handleChange(sectionIndex, q, newAns);
    setAnswers(newAns)
  };

  return (
    <Box>
      <Stack spacing={0.5}>
        {q.options.map((opt, i) => (
          <FormControlLabel
            key={i}
            control={
              <Checkbox
                checked={Array.isArray(answers) && answers.includes(opt.id)}
                onChange={(e) => {
                  if (handleChange) {
                    handleCheckboxChange(opt, e.target.checked)
                  }
                }}
              />
            }
            label={opt.option || t("questionnaire.form.optionWithNo", { number: i + 1 })}
          />
        ))}

      </Stack>

      <QuestionFileUpload
        q={q}
        sectionIndex={sectionIndex}
        isDisabled={isDisabled}
        handleFiles={handleFiles}
      />

      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default CheckboxQuestion;
